import { jwtDecode } from "jwt-decode";
import KeyValueClient from "./services/KeyValueClient";
import config from "./config/config";
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import store from "./Store/Store.js"


function toYYYYMMDD(dateStr) {
    const parts = dateStr.split(' ');
    const day = parts[0].padStart(2, '0');
    const monthMap = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
        Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
    };
    const month = monthMap[parts[1]];
    const year = parts[2];
    return year + month + day;
}

function removeIndianCountryCode(phoneNumber) {
    if (!phoneNumber) return phoneNumber;

    // Remove spaces, dashes, and parentheses
    phoneNumber = phoneNumber.replace(/[\s\-()]/g, "");

    // Remove +91 or 91 only if it's followed by a 10-digit mobile number
    return phoneNumber.replace(/^(\+91|91)(?=[6-9]\d{9}$)/, "");
}

async function updateStatus(ExistingData, Key, NewData, payout_ref) {

    let tokens = localStorage.getItem("authToken");
    if (!tokens) {
        console.log("No token Available");

        return
    }
    let userTokens = JSON.parse(tokens)
    let ParsedValue = JSON.parse(ExistingData) ? JSON.parse(ExistingData) : []
    let ParsedExistingData = ParsedValue && ParsedValue.value
        ? JSON.parse(ParsedValue.value)
        : null;
    // {"20260714121212CUPI8754467987321":{"Category":"Food","tag":"test","ApprovalCode":"Yet_to_submit_bill","purpose":"test purpose"}}
    let obj = {}
    if (!ParsedExistingData) {
        obj = {
            [payout_ref]: NewData
        }
    } else {
        if (!ParsedExistingData[payout_ref]) {
            obj = { ...ParsedExistingData, [payout_ref]: NewData };
        } else {
            let existedPayout = ParsedExistingData[payout_ref]
            ParsedExistingData[payout_ref] = { ...existedPayout, ...NewData }
            obj = ParsedExistingData
        }
    }
    console.log("obj", obj);

    const client = new KeyValueClient(
        config.keystore_endpoint, // ← MUST be Envoy proxy, not 8080
        {
            cognitoToken: userTokens.IdToken
        },
    );
    const data = await client.add(Key, JSON.stringify(obj));
    console.log("Updating Value Fixed", data);
}

async function InvokeGRpc(updation, obj) {
    try {
        let tokens = localStorage.getItem("authToken");
        if (!tokens) {
            console.log("No token Available");

            return
        }
        let userTokens = JSON.parse(tokens);
        const decoded = jwtDecode(userTokens.IdToken);
        const username = decoded["sub"];
         const name = decoded["name"];
        // const phone_number = decoded["phone_number"]
        const phone_number= obj.SelectedMobile_no;
        const Company_id = obj.CompanyId
        const Time = obj?.payoutRef?.substring(0, 8)
        const payoutRef = obj.payoutRef
        if (!phone_number || !payoutRef || !Time || !Company_id) {
            console.log("data is incomplete")
        }
        const newKey = `${Time}_${Company_id}_${removeIndianCountryCode(phone_number)}`
        const client = new KeyValueClient(
            config.keystore_endpoint, // ← MUST be Envoy proxy, not 8080
            {
                cognitoToken: userTokens.IdToken
            },
        );
        const data = await client.get(newKey);
        updateStatus(data, newKey, updation, payoutRef)
    } catch (err) {
        console.log("error", err);

    }
}

function parseCsvLine(line) {
    const result = [];
    let cur = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
                cur += '"';
                i++;
            } else {
                inQuotes = !inQuotes;
            }
        } else if (char === "," && !inQuotes) {
            result.push(cur);
            cur = "";
        } else {
            cur += char;
        }
    }
    result.push(cur);
    return result;
}

function toNumberOrNull(value) {
    const v = (value ?? "").trim();
    if (v === "" || v.toUpperCase() === "NA") return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
}

const readCsvRaw = async (url) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch CSV: ${res.status}`);
    return await res.text();
};

async function useCsvEditor(presignedUrl) {
    const csvText = await readCsvRaw(presignedUrl);

    // Strip a UTF-8 BOM and normalize CRLF/CR, in case the exported file
    // ever comes back with Windows-style line endings.
    const normalized = csvText.replace(/^\uFEFF/, "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    const lines = normalized.trim().split("\n");

    // Row 1: "Opening Balance" metadata row.
    const openingFields = parseCsvLine(lines[0]);
    const openingBalance = {
        amount: toNumberOrNull(openingFields[6]),
        type: openingFields[7]?.trim() || null, // "Cr" or "Dr"
    };

    // Row 2: headers.
    const headers = parseCsvLine(lines[1]).map((h) => h.trim());
    const tagsIndex = headers.indexOf("Tags");
    const numericFields = new Set(["Dr", "Cr", "Balance"]);
    // Columns that always come AFTER Tags (Purpose, Category_id, Status) -
    // used as a fixed anchor so the merge works no matter how many extra
    // commas end up inside Tags.
    const suffixCount = tagsIndex === -1 ? 0 : headers.length - tagsIndex - 1;

    const transactions = lines
        .slice(2)
        .filter((line) => line.trim().length > 0)
        .map((line) => {
            let fields = parseCsvLine(line);

            // Some export rows contain an unescaped comma inside the Tags field
            // (e.g. "Senior VP Sales, Sales"), producing extra column(s).
            // Detect that and merge the overflow back into Tags.
            if (fields.length > headers.length && tagsIndex !== -1) {
                const before = fields.slice(0, tagsIndex);
                const after = fields.slice(fields.length - suffixCount);
                const tagsChunk = fields
                    .slice(tagsIndex, fields.length - suffixCount)
                    .join(",")
                    .trim();
                fields = [...before, tagsChunk, ...after];
            }

            const record = {};
            headers.forEach((h, i) => {
                const raw = (fields[i] ?? "").trim();
                record[h] = numericFields.has(h) ? toNumberOrNull(raw) : raw;
            });

            if (record["Stmt Id"] !== undefined && record["Stmt Id"] !== "") {
                const n = Number(record["Stmt Id"]);
                record["Stmt Id"] = Number.isNaN(n) ? record["Stmt Id"] : n;
            }

            return record;
        });

    return { openingBalance, transactions };
}

const logout = () => {
    try {
        // shutdownIntercom();
    } catch (err) {
        // console.log("error in logoutIntercom", err);
    }
    console.log("clicked");
    localStorage.removeItem("tradeName");
    localStorage.removeItem("authToken");
    localStorage.removeItem("Company_Id");
    localStorage.removeItem("CompanyName");
    localStorage.removeItem("email");
    localStorage.removeItem("KycCompanyId");
    localStorage.removeItem("company_temp_id");
    store.setCompId("");
    store.setCompanyName("");
    store.setUserId("");
    window.location.href = "/login";
};

// Cognito custom attributes (cupi_owner / cupi_admin / cupi_view_admin) come back
// as a JSON-encoded string, e.g. '["EscrowStackPine"]'. This safely parses that
// string and does a real array membership check, instead of a raw string
// .includes() (which does substring matching and false-matches on partial ids,
// and always returns true once companyId is an empty string).
function hasCompanyAccess(rawClaim, companyId) {
    if (!companyId) return false; // never match against an empty/reset id
    let list = [];
    try {
        list = JSON.parse(rawClaim ?? "[]");
    } catch {
        list = [];
    }
    return Array.isArray(list) && list.includes(companyId);
}

async function verifyTokenAccess(Token) {
    console.log("Roles initilized", store.rolesInitialized);
    if (!store.rolesInitialized) {
        console.log("Roles still not initilized", store.rolesInitialized);
        return
    }
    if (store.rolesInitialized) {
        try {
            // Capture the company being checked synchronously, as the very
            // first thing, before any await. A concurrent company switch
            // updates store.Company_Id immediately but only recomputes
            // store.isUserOwner/isUserAdmin/isUserViewAdmin later,
            // asynchronously (Content.js's getUsersAccess) - capturing this
            // now, and using this same value throughout, means this check
            // is always about one specific company from start to finish.
            const companyIdAtCheckStart = store.Company_Id;

            let AllTok = await localStorage.getItem("authToken")
            if (!AllTok) {
                console.log("=====================NO TOKENS+++++++++++++++++++++");
                return
            }
            let parsedTok = JSON.parse(AllTok)
            let refresh = parsedTok?.RefreshToken
            if (!refresh) {
                console.log("=====================NO REFRESH TOKEN+++++++++++++++++++++");
                return
            }

            // Ground truth for "what access the browser currently believes
            // it has" is the ID token already sitting in localStorage - NOT
            // store.isUserOwner/isUserAdmin/isUserViewAdmin, which are
            // written asynchronously (and sometimes more than once per
            // switch) by Content.js's getUsersAccess and can be transiently
            // out of sync with store.Company_Id. Decoding the existing
            // token directly sidesteps that entirely.
            let existingIdToken = parsedTok?.IdToken
            let existingDecodedToken = existingIdToken ? jwtDecode(existingIdToken) : null;
            const existingOwnerAccess = hasCompanyAccess(existingDecodedToken?.["custom:cupi_owner"], companyIdAtCheckStart);
            const existingAdminAccess = hasCompanyAccess(existingDecodedToken?.["custom:cupi_admin"], companyIdAtCheckStart);
            const existingViewAdminAccess = hasCompanyAccess(existingDecodedToken?.["custom:cupi_view_admin"], companyIdAtCheckStart);

            const client = new CognitoIdentityProviderClient({
                region: "ap-south-1",
            });

            const params = {
                ClientId: config.Client_Id,
                AuthFlow: "REFRESH_TOKEN_AUTH",
                AuthParameters: {
                    REFRESH_TOKEN: refresh,
                },
            };

            const command = new InitiateAuthCommand(params);
            const refreshResponse = await client.send(command);

            if (refreshResponse.AuthenticationResult) {
                const newAuthToken = {
                    AccessToken: refreshResponse.AuthenticationResult.AccessToken,
                    RefreshToken: refresh, // Keep old refresh token
                    IdToken: refreshResponse.AuthenticationResult.IdToken,
                };
                let DecodedToken = await jwtDecode(newAuthToken.IdToken)

                // Compare the existing (browser-stored) token's access for
                // this company against the new (Cognito-fresh) token's
                // access for the SAME company. Log out only if Owner,
                // Admin, or ViewAdmin access actually changed - granted,
                // revoked, or changed tier - since the browser last knew
                // about it.
                const newOwnerAccess = hasCompanyAccess(DecodedToken["custom:cupi_owner"], companyIdAtCheckStart);
                const newAdminAccess = hasCompanyAccess(DecodedToken["custom:cupi_admin"], companyIdAtCheckStart);
                const newViewAdminAccess = hasCompanyAccess(DecodedToken["custom:cupi_view_admin"], companyIdAtCheckStart);

                const accessChanged =
                    existingOwnerAccess !== newOwnerAccess ||
                    existingAdminAccess !== newAdminAccess ||
                    existingViewAdminAccess !== newViewAdminAccess;

                console.log("Access check for", companyIdAtCheckStart, {
                    owner: [existingOwnerAccess, newOwnerAccess],
                    admin: [existingAdminAccess, newAdminAccess],
                    viewAdmin: [existingViewAdminAccess, newViewAdminAccess],
                });

                if (accessChanged) {
                    console.log("Cognito access has changed for this company");
                    console.log("DecodedToken", DecodedToken);

                    console.log("Logout");
                    logout()
                }
            } else {
                // localStorage.removeItem("authToken");
                // navigate("/login");
            }
        } catch (error) {
            console.log("Error refreshing tokens:", error);
            // localStorage.removeItem("authToken");
            // navigate("/login");
        }
    }
}

export { InvokeGRpc, useCsvEditor, parseCsvLine, toNumberOrNull, verifyTokenAccess, hasCompanyAccess };